import PropTypes from "prop-types";
import { BugIcon, ExternalLinkIcon, LightbulbIcon } from "lucide-react";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import {
  Item,
  ItemActions,
  ItemContent,
  ItemDescription,
  ItemMedia,
  ItemTitle,
} from "@/components/ui/item";

const INQUIRY_TYPES = [
  {
    id: "bug",
    label: "Bug",
    description: "Something in Pleteo is broken or behaving incorrectly.",
    icon: BugIcon,
    url: "https://rvx-ops.ruvixx.com/bug_report",
  },
  {
    id: "request",
    label: "Request",
    description: "Ask for something new, or a change to how something works.",
    icon: LightbulbIcon,
    url: "https://rvx-ops.ruvixx.com/feature_request",
  },
];

/**
 * Routes the user to the matching rvx-ops intake form. Each choice is a real
 * anchor so middle-click and modifier-click behave as expected.
 */
const SupportRequestDialog = ({ open, onOpenChange }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="tw:sm:max-w-md">
      <DialogHeader>
        <DialogTitle>Submit An Inquiry</DialogTitle>
        <DialogDescription>What would you like to submit?</DialogDescription>
      </DialogHeader>
      <div className="tw:grid tw:gap-2">
        {INQUIRY_TYPES.map(({ id, label, description, icon: Icon, url }) => (
          <Item
            key={id}
            variant="outline"
            render={<a href={url} target="_blank" rel="noopener noreferrer" />}
            onClick={() => onOpenChange(false)}
          >
            <ItemMedia variant="icon">
              <Icon />
            </ItemMedia>
            <ItemContent>
              <ItemTitle>{label}</ItemTitle>
              <ItemDescription>{description}</ItemDescription>
            </ItemContent>
            <ItemActions>
              <ExternalLinkIcon className="tw:size-4 tw:text-muted-foreground" />
            </ItemActions>
          </Item>
        ))}
      </div>
    </DialogContent>
  </Dialog>
);

SupportRequestDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onOpenChange: PropTypes.func.isRequired,
};

export default SupportRequestDialog;
